import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate"
})
export class TruncatePipe implements PipeTransform {

  constructor() { }

  transform(value: string, length = 30): string {
    let truncatedValue = value.slice(0, length - 3)
    if (value.length > length) {
      return truncatedValue + "..."
    }
    return value
  }
}
